import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { Link } from '~/common/components';
import { routes } from '~/constants';
import { useNavigation } from '../../context';

const TenHourTurnaroundBannerCollapsed = () => {
  return (
    <Link.Base
      to={routes.order}
      data-tt="Limited-time 10-hour turnaround offer!"
      data-tt-placement="right"
      className="px-2 py-[12px] rounded-md bg-info-100 border border-solid border-info-200 flex justify-center"
    >
      ⏳
    </Link.Base>
  );
};

const TenHourTurnaroundBannerExpanded = () => {
  return (
    <div className="p-2 rounded-md bg-info-100 border border-solid border-info-200">
      <div className="font-brand-l2 text-text-600 mb-1">⏳ Limited-time offer!</div>
      <div className="font-brand-b3 text-text-400 mb-[12px]">
        Get the benefit of <span className="font-medium">10-hour turnaround</span> - exclusively for
        a short time.
      </div>
      <Link
        to={routes.order}
        color="navy"
        endIcon={faChevronRight}
        size="m"
        iconSize="s"
        className="w-fit"
      >
        Try it now
      </Link>
    </div>
  );
};

// This banner will be shown for limited time only, it's a one off campaign
export const TenHourTurnaroundBanner = () => {
  const { isMenuCollapsed } = useNavigation();

  return isMenuCollapsed ? (
    <TenHourTurnaroundBannerCollapsed />
  ) : (
    <TenHourTurnaroundBannerExpanded />
  );
};
